import React from "react";
import "./terms.css";

import logoWhite from './logo_white.png';

const PaymentPolicy = () => {
  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top px-3">
        <div className="container-fluid">
          <a className="navbar-brand" href="/">
            <img
              src={logoWhite}
              alt="KeyConnect Logo"
              style={{ height: "40px", marginLeft: "20px" }}
            />
          </a>
        </div>
      </nav>

      <section className="legal-page">
        <div className="wrap">
          <h1>Payment Policy</h1>

          <div className="legal-meta">
            <div>
              <strong>Effective Date:</strong> 8<sup>th</sup> July 2025
            </div>
            <div>
              <strong>Website:</strong>{" "}
              <a
                href="https://www.keyconnect.in"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.keyconnect.in
              </a>
            </div>
            <div>
              <strong>Platform:</strong> KeyConnect CRM
            </div>
          </div>

          <p>
            This <strong>Payment Policy</strong> governs billing, invoicing,
            subscription cycles, and related payment terms for clients
            ("you" or "Client") using the <strong>KeyConnect CRM</strong>{" "}
            platform ("we", "our", "KeyConnect").
          </p>

          <p>
            By subscribing to or using our services, you agree to this
            Payment Policy.
          </p>

          <section>
            <h2>1. Billing Cycle</h2>
            <ul>
              <li>
                Subscriptions are billed on a{" "}
                <strong>monthly, quarterly, bi-annual</strong>, or{" "}
                <strong>annual</strong> basis depending on the plan selected
                at signup or contract agreement.
              </li>
              <li>
                The billing cycle begins on the{" "}
                <strong>date of plan activation</strong> and recurs
                automatically unless cancelled.
              </li>
              <li>Invoices are generated at the beginning of each billing period.</li>
            </ul>
          </section>

          <section>
            <h2>2. Payment Terms</h2>
            <ul>
              <li>
                Payment is due within <strong>15 calendar days</strong> of
                invoice issuance.
              </li>
              <li>Accepted payment method is only Bank Transfer (RTGS/NEFT/IMPS).</li>
              <li>
                All prices are{" "}
                <strong>exclusive of applicable taxes</strong> (e.g., GST).
              </li>
            </ul>
          </section>

          <section>
            <h2>3. Late Payments</h2>
            <ul>
              <li>
                A <strong>grace period of 7 days</strong> is allowed after
                the due date.
              </li>
              <li>
                After the grace period:
                <ul>
                  <li>
                    A <strong>2% monthly late fee</strong> may be applied to
                    the outstanding amount.
                  </li>
                  <li>
                    Services may be <strong>temporarily suspended</strong>{" "}
                    if payment is not received within{" "}
                    <strong>21 days</strong>.
                  </li>
                  <li>
                    After <strong>30 days</strong>, the account may be{" "}
                    <strong>terminated</strong>, and data may be deleted per
                    our Termination Policy.
                  </li>
                </ul>
              </li>
            </ul>
          </section>

          <section>
            <h2>4. Plan Changes (Upgrades &amp; Downgrades)</h2>
            <ul>
              <li>
                <strong>Upgrades</strong> may be made at any time and are{" "}
                <strong>billed pro-rata</strong> for the remaining billing
                cycle.
              </li>
              <li>
                <strong>Downgrades</strong> require a{" "}
                <strong>15-day written notice</strong> before the next
                billing cycle and take effect in the following period.
              </li>
              <li>Mid-cycle downgrades are not eligible for refunds or credits.</li>
            </ul>
          </section>

          <section>
            <h2>5. Add-On Charges</h2>
            <ul>
              <li>
                Fees for integrations with third-party platforms (e.g.,
                WhatsApp, IVR, Meta API, SMS credits) may be charged
                separately.
              </li>
              <li>
                These services may have their own billing schedules and
                must be prepaid or topped up as required.
              </li>
            </ul>
          </section>

          <section>
            <h2>6. Refund Policy</h2>
            <ul>
              <li>
                <strong>No refunds</strong> are provided for monthly
                subscriptions once the billing cycle has started.
              </li>
              <li>
                For <strong>annual plans</strong>, partial refunds may be
                issued{" "}
                <strong>
                  only if cancellation occurs before the start of a new
                  quarter
                </strong>{" "}
                and is approved in writing.
              </li>
              <li>
                Fees paid for third-party integrations or one-time setups
                are <strong>non-refundable</strong>.
              </li>
            </ul>
          </section>

          <section>
            <h2>7. Auto-Renewal</h2>
            <ul>
              <li>
                All subscriptions are automatically renewed at the end of
                each billing cycle unless cancelled.
              </li>
              <li>
                Clients will be notified in advance via email about
                upcoming renewals and plan expiration (where applicable).
              </li>
            </ul>
          </section>

          <section>
            <h2>8. Cancellation</h2>
            <ul>
              <li>
                You may cancel your subscription by submitting a written
                request to{" "}
                <a href="mailto:support@keyconnect.in">support@keyconnect.in</a>{" "}
                at least <strong>15 days before</strong> the end of your
                billing period.
              </li>
              <li>
                For cancellation-related conditions, please refer to our{" "}
                <a href="/cancellation-policy" target="_blank" rel="noopener noreferrer">
                  Cancellation &amp; Termination Policy
                </a>
                .
              </li>
            </ul>
          </section>

          <section>
            <h2>9. Disputed Charges</h2>
            <p>
              If you believe a charge has been made in error, you must
              notify us in writing within{" "}
              <strong>7 days of receiving the invoice</strong>. We will
              investigate the matter and resolve it in a timely manner.
            </p>
          </section>

          <section>
            <h2>10. Contact for Billing &amp; Payments</h2>
            <p>
              <strong>KeyConnect CRM – Billing Department</strong>
              <br />
              Email:{" "}
              <a href="mailto:support@keyconnect.in">support@keyconnect.in</a>
              <br />
              Phone: +91-6363114836
              <br />
              Website:{" "}
              <a
                href="https://www.keyconnect.in"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.keyconnect.in
              </a>
            </p>
          </section>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-dark text-light text-center py-4">
        <small>
          &copy; {new Date().getFullYear()} KeyConnect CRM. All rights reserved.
        </small>
      </footer>
    </div>
  );
};

export default PaymentPolicy;